import { HStack, Tag, Text } from '@chakra-ui/react';
import { useUserContext } from 'context/UserContextProvider';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

import { getStatus } from '../helpers/general';
import { getDarkStatusColor, getTextStatusColor } from '../helpers/getColourSchemeBasedOnStatus';
import { getI18nKeyForStatusReason, getI18nKeysForStatus, resolveStatusName } from '../helpers/statusTranslations';

export const StatusTag = (props: {
  completedAt?: string;
  currentStatus: number | string;
  currentStatusReason?: number;
  resourceKey: string;
  isCell?: boolean;
  width?: string;
  textTransform?: any;
  isVerification?: boolean;
}) => {
  const { t } = useTranslation();
  const {
    resourceKey,
    currentStatus,
    currentStatusReason,
    completedAt,
    isCell,
    textTransform = 'uppercase',
    width = 'inherit',
    isVerification,
  } = props;

  const { statusCodes } = useUserContext();

  const resourceStatusCodes = get(statusCodes, resourceKey);
  const resourceStatusReasonsCodes = get(statusCodes, resourceKey + '_reasons');

  // The status only resolves to a translatable label when the code exists in the
  // loaded status map. If the map is unavailable (e.g. the status endpoint failed
  // to load) the code is unmapped, and translating it would request a missing key
  // like "service_record:status.500". Skip translation in that case.
  const statusName = resolveStatusName(resourceStatusCodes, currentStatus);

  return (
    <HStack>
      <Tag
        size={'md'}
        variant="solid"
        textTransform={textTransform ? textTransform : 'inherit'}
        flexShrink={0}
        paddingBlock={2}
        textAlign={'center'}
        display={'block'}
        whiteSpace={'normal'}
        width={width}
        bgColor={getDarkStatusColor(statusName)}
        color={getTextStatusColor(statusName)}
      >
        {statusName ? t(getI18nKeysForStatus(statusCodes, resourceKey, currentStatus)) : null}
      </Tag>

      {!isCell &&
        resourceStatusReasonsCodes &&
        currentStatusReason &&
        (isVerification ? (
          <Text as={'div'}>{statusName ? t(getI18nKeysForStatus(statusCodes, resourceKey, currentStatus)) : null}</Text>
        ) : (
          <Text as={'div'}>{t(getI18nKeyForStatusReason(statusCodes, resourceKey, currentStatus, currentStatusReason))}</Text>
        ))}
      {!isCell && currentStatus === getStatus(statusCodes ?? {}, 'completed') && completedAt ? <Text>({completedAt})</Text> : null}
    </HStack>
  );
};
